var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "hotel-block" }, [
        _c("div", { staticClass: "hotel-block-title" }, [
          _c("div", { staticClass: "order-number" }, [
            _vm._v(_vm._s(_vm.$t("order_sn")) + "：" + _vm._s(_vm.order_sn))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-status" }, [
            _vm._v(_vm._s(_vm.status_msg))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hotel-block-content" }, [
          _c("div", { staticClass: "hotel-block-img" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block-content" },
            [
              _c("h3", { staticClass: "content-title" }, [
                _vm._v(_vm._s(_vm.hotel_name))
              ]),
              _vm._v(" "),
              _c("star", { attrs: { level: _vm.hotel_star } }),
              _vm._v(" "),
              _c("p", { staticClass: "content-text" }, [
                _vm._v(
                  _vm._s(_vm.hotel_addr) +
                    ", " +
                    _vm._s(_vm.city_name) +
                    ", " +
                    _vm._s(_vm.city_name)
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "booking-info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.room_type) +
                      " " +
                      _vm._s(_vm.room_count) +
                      _vm._s(_vm.$t("room")) +
                      " " +
                      _vm._s(_vm.dur) +
                      _vm._s(_vm.$t("night"))
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("check_in_date")) +
                      ": " +
                      _vm._s(_vm.startDate)
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("check_out_date")) +
                      ": " +
                      _vm._s(_vm.endDate)
                  )
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hotel-block-footer" }, [
          _c(
            "button",
            { staticClass: "btn-primary", on: { click: _vm.toPay } },
            [
              _vm._v(
                _vm._s(_vm.$t("pay")) +
                  " " +
                  _vm._s(_vm.currency) +
                  " " +
                  _vm._s(_vm.amount) +
                  " (" +
                  _vm._s(_vm.$t("remaining")) +
                  " " +
                  _vm._s(_vm.remaining) +
                  ")"
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5c46f00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c46f00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Public/components/HotelBlock.vue
// module id = null
// module chunks = 